import React from 'react';
import PlaceIcon from '@mui/icons-material/Place';
import PhoneIcon from '@mui/icons-material/Phone';
import { NonceProvider } from 'react-select';
import QRCode from "../QRCode/qrcode.jpg";
import EmailIcon from '@mui/icons-material/Email';
const InvoicePrint = ({ onClose, labelData }) => {
    const containerStyle = {
        border: '1px solid #000',
        padding: '2px',
        width: '600px',
        height: '900px',
        margin: '5px auto',
    };

    const firstItem = labelData[0];
    const NumberToWords = (num) => {
        const belowTwenty = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
        const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
        const thousands = ["", "Thousand", "Lakh", "Crore"];

        const convert = (n) => {
            if (n === 0) return "";
            if (n < 20) return belowTwenty[n] + " ";
            if (n < 100) return tens[Math.floor(n / 10)] + " " + belowTwenty[n % 10] + " ";
            if (n < 1000) return belowTwenty[Math.floor(n / 100)] + " Hundred " + (n % 100 !== 0 ? convert(n % 100) : "");

            // Corrected loop for thousands
            for (let i = 0; i < thousands.length; i++) {
                const divisor = Math.pow(1000, i + 1); // 1000, 100000, 10000000...
                if (n < divisor) {
                    const currentDivisor = Math.pow(1000, i); // Get the current divisor (1000, 100000, etc.)
                    return convert(Math.floor(n / currentDivisor)) + " " + thousands[i] + " " + (n % currentDivisor !== 0 ? convert(n % currentDivisor) : "");
                }
            }
        };

        return convert(num).trim();
    };

    const AmountInWords = ({ amount }) => {
        const cleanedAmount = parseFloat(amount || 0).toFixed(2); // Ensure amount is valid
        const [rupees, decimal = "00"] = cleanedAmount.split('.');

        return (
            <div>
                <h5>Rupees {NumberToWords(parseInt(rupees))}Only</h5>
                {parseInt(decimal) > 0 && (
                    <p>{NumberToWords(parseInt(decimal))} Paise Only</p>
                )}
            </div>
        );
    };

    return (
        <div style={{ ...containerStyle, padding: '2px', marginLeft: '-0.92%' }}>
            {/* <style>{printStyles}</style> */}
            {firstItem && firstItem.SaleOrderPrint && (
                <div>
                    <h4 style={{ textAlign: 'center', marginTop: '10px', color: 'blue', fontWeight: 'bold' }}>
                        {firstItem.SaleOrderPrint.CompanyName}
                    </h4>

                    <div style={{ marginTop: '-5px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '-5px' }}>
                            <PlaceIcon style={{ color: 'green', width: '30px', height: '30px' }} />
                            <span style={{ marginLeft: '5px', color: 'black', fontWeight: 'normal', fontSize: '16px' }}>
                                {firstItem.SaleOrderPrint.Address}, {firstItem.SaleOrderPrint.Address1} , {firstItem.SaleOrderPrint.Location} - {firstItem.SaleOrderPrint.Pincode}
                            </span>
                        </div>
                        {/* <div style={{ marginLeft: '35px', marginBottom: '5px' }}>
                            <span style={{ color: 'black', fontWeight: 'bolder', fontSize: '16px' }}>
                                {firstItem.SaleOrderPrint.Location} - {firstItem.SaleOrderPrint.Pincode}
                            </span>
                        </div> */}

                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                            <PhoneIcon style={{ color: 'blue', width: '30px', height: '30px' }} />
                            <span style={{ marginLeft: '5px', color: 'black', fontWeight: 'normal', fontSize: '16px' }}>
                                {firstItem.SaleOrderPrint.CompanyContactNumber}
                            </span>
                            {/* </div>

                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}> */}
                            <EmailIcon style={{ color: 'blue', width: '30px', height: '30px', marginLeft: '5px' }} />
                            <span style={{ marginLeft: '5px', color: 'black', fontWeight: 'normal', fontSize: '15px' }}>
                                {firstItem.SaleOrderPrint.Email}
                            </span>
                        </div>

                        <div style={{ marginLeft: '5px', marginTop: '10px' }}>
                            <h3 style={{ fontWeight: 'normal', fontSize: '15px' }}>
                                GST NO: {firstItem.SaleOrderPrint.GSTNumber}
                            </h3>
                        </div>
                    </div>

                    <hr style={{ border: 'none', marginTop: '10px', borderTop: '1px solid black', margin: '20px -20px', width: 'calc(100% + 29px)' }} />

                    <div style={{ position: 'absolute', top: '30px', right: '20px' }}>
                        <img src={QRCode} alt="QR Code" style={{ width: '100px', height: '100px' }} />
                    </div>

                    <h2 style={{ textAlign: 'center', marginTop: '-10px', fontSize: '15px', fontWeight: 'bold' }}>
                        {firstItem.SaleOrderPrint.IsReprint ? 'TAX INVOICE (Reprinted)' : 'TAX INVOICE'}
                    </h2>

                    <div style={{ marginBottom: '5px', fontSize: '13px', marginTop: '-10px' }}>
                        <strong style={{ fontSize: '13px', fontWeight: 'normal' }}>Customer <span style={{ marginLeft: '15px' }}> :</span> <span style={{ marginLeft: '5px', fontWeight: 'normal' }}>{firstItem.SaleOrderPrint.Name}</span></strong>
                    </div>

                    <div style={{ marginBottom: '5px', fontSize: '14px' }}>
                        <strong style={{ fontSize: '13px', fontWeight: 'normal' }}>Phone No <span style={{ marginLeft: '15px' }}> :</span> <span style={{ marginLeft: '5px', fontWeight: 'normal' }}>{firstItem.SaleOrderPrint.ContactNumber}</span></strong>
                    </div>
                    <div style={{ marginBottom: '5px', fontSize: '14px' }}>
                        <strong style={{ fontSize: '13px', fontWeight: 'normal' }}>Place <span style={{ marginLeft: '44px' }}> :</span> <span style={{ marginLeft: '5px', fontWeight: 'normal' }}>{firstItem.SaleOrderPrint.CustomerAddess}</span></strong>
                    </div>

                    <div style={{ marginBottom: '5px', fontSize: '14px' }}>
                        <strong style={{ fontSize: '13px', fontWeight: 'normal' }}>Pincode <span style={{ marginLeft: '28px' }}> :</span> <span style={{ marginLeft: '5px', fontWeight: 'normal' }}>{firstItem.SaleOrderPrint.CustomerPincode}</span></strong>
                    </div>

                    {/* <div style={{ marginBottom: '5px', fontSize: '14px' }}>
                        <strong style={{ fontSize: '13px', fontWeight: 'normal' }}>GST No <span style={{ marginLeft: '28px' }}> :</span> <span style={{ marginLeft: '5px', fontWeight: 'normal' }}>{firstItem.SaleOrderPrint.CustomerGSTNumber}</span></strong>
                    </div> */}

                    {firstItem?.SaleOrderPrint?.CustomerGSTNumber &&
                        firstItem.SaleOrderPrint.CustomerGSTNumber !== "null" &&
                        firstItem.SaleOrderPrint.CustomerGSTNumber !== "undefined" &&
                        firstItem.SaleOrderPrint.CustomerGSTNumber.trim() !== "" && (
                            <div style={{ marginBottom: '5px', fontSize: '14px' }}>
                                <strong style={{ fontSize: '13px', fontWeight: 'normal' }}>
                                    GST No <span style={{ marginLeft: '28px' }}> :</span>
                                    <span style={{ marginLeft: '5px', fontWeight: 'normal' }}>
                                        {firstItem.SaleOrderPrint.CustomerGSTNumber}
                                    </span>
                                </strong>
                            </div>
                        )}


                    {/* {firstItem.SaleOrderPrint.TaxMethod === 1 && (
                        <div style={{ marginBottom: '5px', fontSize: '14px' }}>
                            <strong style={{ fontSize: '14px', fontWeight: 'normal' }}>Vehicle No <span style={{ marginLeft: '9px' }}> :</span> <span style={{ marginLeft: '5px', fontWeight: 'normal' }}>{firstItem.SaleOrderPrint.Vehicleno}</span></strong>
                        </div>
                    )} */}

                    {/* <div style={{ marginBottom: '5px', fontSize: '14px' }}>
                        <strong style={{ fontSize: '14px', fontWeight: 'normal' }}>Vehicle No <span style={{ marginLeft: '9px' }}> :</span> <span style={{ marginLeft: '5px', fontWeight: 'normal' }}>{firstItem.SaleOrderPrint.Vehicleno}</span></strong>
                    </div> */}

                    <div style={{ marginBottom: '5px', fontSize: '14px' }}>
                        {firstItem.SaleOrderPrint.Vehicleno ? (
                            <strong style={{ fontSize: '14px', fontWeight: 'normal' }}>
                                Vehicle No <span style={{ marginLeft: '9px' }}> :</span>
                                <span style={{ marginLeft: '5px', fontWeight: 'normal' }}>
                                    {firstItem.SaleOrderPrint.Vehicleno}
                                </span>
                            </strong>
                        ) : null}
                    </div>

                    <div style={{ textAlign: 'right', marginBottom: '5px', fontSize: '14px', marginTop: '-10px' }}>
                        <strong style={{ fontSize: '14px', marginTop: '-10px', fontWeight: 'normal' }}>Invoice No:{firstItem.SaleOrderPrint.prefix}{firstItem.SaleOrderPrint.OrderNumber}/{firstItem.SaleOrderPrint.FinYear}</strong>
                    </div>

                    <div style={{ textAlign: 'right', marginBottom: '5px', fontSize: '14px' }}>
                        <strong style={{ fontSize: '14px', marginTop: '-10px', fontWeight: 'normal' }}>Invoice Date: {new Date(firstItem.SaleOrderPrint.OrderDate).toLocaleDateString('en-GB')}</strong>
                    </div>
                </div>

            )}

            {
                firstItem && firstItem.SaleOrderPrintItems && (
                    <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '-5px' }}>

                        <thead>
                            <tr >
                                {firstItem.SaleOrderPrint.TaxMethod === 1 && (
                                    <>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: 'bold', width: '50px', fontWeight: 'normal', fontSize: '12px' }}>Sl</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: 'bold', fontWeight: 'normal' }}>HSN</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: 'bold', width: '270px', fontWeight: 'normal', fontSize: '12px' }}>Name</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: 'bold', width: '50px', fontWeight: 'normal', fontSize: '12px' }}>Rate </th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: 'bold', width: '50px', fontWeight: 'normal', fontSize: '12px' }}>Discount</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: 'bold', width: '30px', fontWeight: 'normal', fontSize: '12px' }}>GST(%)</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: 'bold', width: '50px', fontWeight: 'normal', fontSize: '12px' }}>Qty</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: 'bold', width: '70px', fontWeight: 'normal', fontSize: '12px' }}>Taxable Amt</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: 'bold', width: '70px', fontWeight: 'normal', fontSize: '12px' }}>GST</th>

                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: 'bold', width: '100px', fontWeight: 'normal', fontSize: '12px' }}>Total Amt</th>
                                    </>
                                )}

                                {firstItem.SaleOrderPrint.TaxMethod === 2 && (
                                    <>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: 'bold', fontWeight: 'normal', fontSize: '12px' }}>Sl</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: 'bold', fontWeight: 'normal', fontSize: '12px' }}>HSN</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: 'bold', width: '270px', fontWeight: 'normal', fontSize: '12px' }}>Name</th>
                                        {/* <th style={{ border: '1px solid #000', padding: '5px', fontWeight: '17px' }}>ItemCode</th> */}
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: 'bold', width: '50px', fontWeight: 'normal', fontSize: '12px' }}>Rate</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: 'bold', width: '50px', fontWeight: 'normal', fontSize: '12px' }}>Discount</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: 'bold', width: '30px', fontWeight: 'normal', fontSize: '12px' }}>GST(%)</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: 'bold', width: '50px', fontWeight: 'normal', fontSize: '12px' }}>Qty</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: 'bold', width: '70px', fontWeight: 'normal', fontSize: '12px' }}>Taxable Amt</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: 'bold', width: '70px', fontWeight: 'normal', fontSize: '12px' }}>GST</th>
                                        <th style={{ border: '1px solid #000', padding: '2px', fontWeight: 'bold', width: '100px', fontWeight: 'normal', fontSize: '12px' }}>Total Amt</th>
                                    </>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {firstItem.SaleOrderPrintItems.map((item, index) => (

                                <tr key={index}>
                                    {firstItem.SaleOrderPrint.TaxMethod === 1 && (
                                        <>
                                            <td style={{ border: '1px solid #000', padding: '2px', color: 'black', fontSize: '12px' }}>{index + 1}</td>
                                            <td style={{ border: '1px solid #000', padding: '2px', color: 'black', fontSize: '12px' }}>{item.HSNCODE}</td>
                                            <td style={{ border: '1px solid #000', padding: '2px', color: 'black', fontSize: '12px' }}>{item.ItemName}</td>
                                            <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'right', color: 'black', fontSize: '12px' }}>{item.Rate.toFixed(2)}</td>
                                            <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'right', color: 'black', fontSize: '12px' }}>{(item.Discount)}</td>
                                            <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'center', color: 'black', fontSize: '12px' }}>{(item.GstRate)}</td>
                                            <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'center', color: 'black', fontSize: '12px' }}>{item.Quantity}</td>
                                            <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'right', color: 'black', fontSize: '12px' }}>{(item.taxableamount || 0).toFixed(2)}</td>
                                            {/* <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'right', color: 'black', fontSize: '12px' }}>{(item.CGSTAmount + item.SGSTAmount).toFixed(2)}</td> */}
                                            <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'right', color: 'black', fontSize: '12px' }}>{(item.GSTAmt || 0).toFixed(2)}</td>

                                            <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'right', color: 'black', fontSize: '12px' }}>{(item.TotalAmount || 0).toFixed(2)}</td>
                                        </>
                                    )}
                                    {firstItem.SaleOrderPrint.TaxMethod === 2 && (
                                        <>
                                            <td style={{ border: '1px solid #000', padding: '2px', color: 'black', fontSize: '12px' }}>{index + 1}</td>
                                            <td style={{ border: '1px solid #000', padding: '2px', color: 'black', fontSize: '12px' }}>{item.HSNCODE}</td>
                                            <td style={{ border: '1px solid #000', padding: '2px', color: 'black', fontSize: '12px' }}>{item.ItemName}</td>
                                            <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'right', color: 'black', fontSize: '12px' }}>{item.Rate.toFixed(2)}</td>
                                            <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'right', color: 'black', fontSize: '12px' }}>{(item.Discount)}</td>
                                            <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'center', color: 'black', fontSize: '12px' }}>{(item.GstRate)}</td>
                                            {/* <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold', color: 'black' }}>{item.ItemCode}</td> */}
                                            <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'center', color: 'black', fontSize: '12px' }}>{item.Quantity}</td>
                                            <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'right', color: 'black', fontSize: '12px' }}>{(item.taxableamount || 0).toFixed(2)}</td>
                                            {/* <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'right', color: 'black', fontSize: '12px' }}>{(item.CGSTAmount + item.SGSTAmount).toFixed(2)}</td> */}
                                            <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'right', color: 'black', fontSize: '12px' }}>{(item.GSTAmt || 0).toFixed(2)}</td>

                                            <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'right', color: 'black', fontSize: '12px' }}>{(item.TotalAmount || 0).toFixed(2)}</td>
                                        </>
                                    )}
                                </tr>
                            ))}
                        </tbody>

                        <tbody>
                            <tr>
                                {/* Bank Details */}
                                <td style={{ border: '1px solid #000', padding: '2px', color: 'black' }} colSpan="8">
                                    <table style={{ width: '100%' }}>

                                        <thead>
                                            <tr>
                                                <th style={{ border: 'none', padding: '2px', color: 'black', textAlign: 'left', fontWeight: 'normal', fontSize: '12px' }}>BANK   <span style={{ marginLeft: '37px' }}> :</span><span style={{ marginLeft: '5px' }}>  AXIS BANK </span></th>
                                            </tr>
                                            {/* </thead> */}

                                            <tr>
                                                <th style={{ border: 'none', padding: '2px', color: 'black', textAlign: 'left', fontWeight: 'normal', fontSize: '12px' }}>BRANCH  <span style={{ marginLeft: '20px' }}> :</span> <span style={{ marginLeft: '5px' }}>ANGAMALY </span></th>
                                            </tr>
                                            <tr>
                                                <th style={{ border: 'none', padding: '2', color: 'black', textAlign: 'left', fontWeight: 'normal', fontSize: '12px' }}>A/C NAME  <span style={{ marginLeft: '12px' }}> :</span> <span style={{ marginLeft: '5px' }}>PETERS RICE MILL</span></th>
                                            </tr>
                                            <tr>
                                                <th style={{ border: 'none', padding: '2px', color: 'black', textAlign: 'left', fontWeight: 'normal', fontSize: '12px' }}>A/C NO <span style={{ marginLeft: '30px' }}> :</span> <span style={{ marginLeft: '5px' }}>922030028095826</span></th>
                                            </tr>
                                            <tr>
                                                <th style={{ border: 'none', padding: '2px', color: 'black', textAlign: 'left', fontWeight: 'normal', fontSize: '12px' }}>IFSC   <span style={{ marginLeft: '45px' }}> :</span> <span style={{ marginLeft: '5px' }}> UTIB0001646</span></th>
                                            </tr>
                                            <tr>
                                                <th style={{ border: 'none', padding: '2px', color: 'black', textAlign: 'left' }}></th>
                                            </tr>
                                        </thead>
                                    </table>
                                </td>



                                {/* Empty Space */}
                                {/* <td style={{ border: '1px solid #000', width: '10px' }} colSpan="3"></td> */}

                                {/* Amount Details */}
                                <td style={{ border: '1px solid #000', padding: '2px', color: 'black' }} colSpan="1">
                                    <table style={{ width: '100%' }}>

                                        <tbody>
                                            <tr>
                                                <td style={{ padding: '2px', color: 'black', textAlign: 'left', fontSize: '13px' }}>NetValue</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '2px', color: 'black', textAlign: 'left', fontSize: '13px' }}>Discount</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '2px', color: 'black', textAlign: 'left', fontSize: '13px' }}>CGST</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '2px', color: 'black', textAlign: 'left', fontSize: '13px' }}>SGST</td>
                                            </tr>
                                            {/* <tr>
                                                <td style={{ padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'left' }}>Discount</td>
                                            </tr> */}
                                            <tr>
                                                <td style={{ padding: '2px', color: 'black', textAlign: 'left', fontSize: '13px' }}>RoundOff</td>
                                            </tr>

                                            <tr>
                                                <td style={{ padding: '2px', color: 'black', textAlign: 'left', fontSize: '13px' }}>GrandTotal</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>

                                <td style={{ border: '1px solid #000', padding: '2px', color: 'black' }} colSpan="1">
                                    <table style={{ width: '100%' }}>

                                        <tbody>
                                            <tr>
                                                <td style={{ padding: '2px', color: 'black', textAlign: 'right', fontSize: '13px' }}>{(firstItem.SaleOrderPrint.NetAmount).toFixed(2)}</td>
                                            </tr>
                                             <tr>
                                                <td style={{ padding: '2px', color: 'black', textAlign: 'right', fontSize: '13px' }}>{(firstItem.SaleOrderPrint.TotalDiscount).toFixed(2)}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '2px', color: 'black', textAlign: 'right', fontSize: '13px' }}>{(firstItem.SaleOrderPrint.CGSTAmount).toFixed(2)}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '2px', color: 'black', textAlign: 'right', fontSize: '13px' }}>{(firstItem.SaleOrderPrint.SGSTAmount).toFixed(2)}</td>
                                            </tr>
                                            {/* <tr>
                                                <td style={{ padding: '5px', fontWeight: 'bold', color: 'black', textAlign: 'right' }}>{(firstItem.SaleOrderPrint.TotalDiscount).toFixed(2)}</td>
                                            </tr> */}
                                            <tr>
                                                <td style={{ padding: '2px', color: 'black', textAlign: 'right', fontSize: '13px' }}>{(firstItem.SaleOrderPrint.RoundOff).toFixed(2)}</td>
                                            </tr>

                                            <tr>
                                                <td style={{ padding: '2px', color: 'black', textAlign: 'right', fontSize: '13px' }}>{(firstItem.SaleOrderPrint.TotalAmount).toFixed(2)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>


                            </tr>

                        </tbody>

                    </table>

                )
            }

            {firstItem && firstItem.SaleOrderPrint && (
                <div>
                    <h5 style={{ marginTop: '-10px', marginLeft: '10px', marginBottom: '2px' }}><AmountInWords amount={firstItem.SaleOrderPrint.TotalAmount} /></h5>

                </div >
            )}
            <div>
                <h5 style={{ marginTop: '-10px', marginLeft: '10px', marginBottom: '2px' }}>
                    <u>Declaration</u>
                </h5>
                <p style={{ marginLeft: '10px', marginTop: '2px', fontSize: '12px' }}>
                    We declare that this invoice shows the actual price of the goods described and that all particulars are true and correct.
                </p>
            </div>

        </div >
    );
};

export default InvoicePrint;
